export const spinner = (state) => {
  
    return {
      type:"LOADING",
      "state":state
    }
  };